<template>
<section class="ressource-result" style="padding-top: 3rem;">
  <div class="container">
    <b-col lg="8" offset-lg="2" mx="auto">
      <Search :isNavbar="false" :defaultValue="keywords" />
      <p class="search-form_results mt-2">
        {{ content.search.resultsFeedbackStart }} {{ resourcesTotalCount }} {{ content.search.result | pluralize(resourcesTotalCount)}} {{ content.search.resultsFeedbackEnd }} "{{ keywords }}"
        <a href="/topics" v-if="!resourcesTotalCount">See all topics</a>
      </p>
    </b-col>
    </div>
    <ResourceList :keywords="keywords"/>
</section>
</template>

<script>
import ResourceList from '@/components/ResourceList'
import Search from '@/components/Search'
import { mapGetters } from 'vuex'
import { pageMixin } from '@/mixins/pageMixin'
import { trackSearchSearched } from '@/utils/analytics/main'

export default {
  name: 'SearchResult',
  mixins: [pageMixin],
  data () {
    return {
      resources: 'resource'
    }
  },
  components: {
    ResourceList,
    Search
  },
  computed: {
    content () {
      return require('@/content.json')
    },
    keywords () {
      return this.$route.query.q
    },
    ...mapGetters(['resourcesTotalCount'])
  },
  mounted () {
    // NOTE: (Florent) Not the best way to track search event
    // But that will do for now
    const params = {
      query: this.keywords,
      results_count: this.resourcesTotalCount
    }
    trackSearchSearched(params)
  }
}
</script>
